<template>
  <div class="p-8 bg-white">
    <div class="flex justify-end w-full"></div>
    <div class="bg-white relative h-full mt-6">
      <div class="w-full">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-responsive table-flush cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-color"
          ><el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="versionName" label="Version" min-width="50px">
            <template slot-scope="scope">
              <P class="text-gray">{{ scope.row.versionNumber }}</P>
            </template>
          </el-table-column>
          <el-table-column label="Updated Points" min-width="50px">
            <template slot-scope="scope">
              <p v-html="scope.row.description"></p>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Created Date" min-width="50px">
            <template slot-scope="scope">
              <P class="text-gray">{{
                new Date(scope.row.createdAt).toDateString()
              }}</P>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            @current-change="
              (value) => {
                currentPage = value;
                getVersion();
              }
            "
            layout="prev,pager,next"
            :per-size="10"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeName: "first",
      drawer: false,
      currentPage: 1,
      pageCount: 0,
      input: "",
      tableData: [],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async getVersion() {
      let payload = {
        pagination: true,
        offset: 10 * this.currentPage - 10,
      };
      if (process.env.VUE_APP_COMMUNITY_NAME === "nhrdn") {
        Object.assign(payload, { projectName: "brained-admin-vue" });
      } else {
        Object.assign(payload, {
          projectName: process.env.VUE_APP_COMMUNITY_NAME,
        });
      }

      let data = await this.$store.dispatch("user/getVersion", payload);
      this.tableData = data.data.data;
      this.pageCount = data.data.count;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
  },

  computed: {
    ...mapState("user", ["versions"]),
  },
  mounted() {
    this.getVersion();
    // this.tableData = this.versions;
  },
};
</script>
